var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDownload = function SvgIconDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 6.16732H12.4167L9.91667 2.83398H2.83333C2.61232 2.83398 2.40036 2.92178 2.24408 3.07806C2.0878 3.23434 2 3.4463 2 3.66732V18.6673C2 19.3304 2.26339 19.9662 2.73223 20.4351C3.20107 20.9039 3.83696 21.1673 4.5 21.1673H19.5C20.163 21.1673 20.7989 20.9039 21.2678 20.4351C21.7366 19.9662 22 19.3304 22 18.6673V7.00065C22 6.77964 21.9122 6.56768 21.7559 6.4114C21.5996 6.25512 21.3877 6.16732 21.1667 6.16732ZM12.5892 18.4232C12.4329 18.5794 12.221 18.6671 12 18.6671C11.779 18.6671 11.5671 18.5794 11.4108 18.4232L8.0775 15.0898C7.75211 14.7644 7.75211 14.2369 8.0775 13.9115C8.40289 13.5861 8.93045 13.5861 9.25583 13.9115L11.1667 15.8223V10.334C11.1667 9.87375 11.5398 9.50065 12 9.50065C12.4602 9.50065 12.8333 9.87375 12.8333 10.334V15.8223L14.7442 13.9115C15.0696 13.5861 15.5971 13.5861 15.9225 13.9115C16.2479 14.2369 16.2479 14.7644 15.9225 15.0898L12.5892 18.4232Z",
    fill: "#A9ADBB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconDownload.73b54d87.svg";
export { ForwardRef as ReactComponent };